import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../../components/Layoutthree";
import { SEO } from "../../components/seo";

const CaseStudy2 = () => {
  return (
    <Layout>
      <Helmet title="A Smart Wellness Digital Solution" />
      <section className="casestudy">
        <section className="top-banner-overlay">
          <div className="title-image-case2 ">
            <div className="overlay"></div>
          </div>
          <div className="container py-5">
            <div className="main-card">
              <div className="section-title">
                A Smart Wellness Digital Solution
              </div>
              <br /> <br />
              <div className="culture-content px-2">
                <h3>About gWell</h3>

                <p>
                  Software development spans many different sectors. We love it
                  when we can help businesses make a difference. gWell is a
                  health start-up based in Boston that provides individualized
                  health plans. What sets gWell apart is their use of genomics
                  for advanced and accurate results. Their smart wellness
                  platform uses affordable gene sequencing techniques. It then
                  provides actionable wellness tasks. These precise
                  recommendations are delivered through a combination of digital
                  and human interactions. This innovative company is taking
                  healthcare to a new level. gWell’s goal is to empower people
                  to take charge of their personal well-being. First,
                  information is gathered on lifestyle, health goals, medical
                  history and genetic make-up. A patented recommendation engine
                  is then used to deliver feedback. gWell began with a focus on
                  bone, muscle and joint health. The service has now expanded to
                  nutrition, sleep, pain relief and mental health. This company
                  was the brainchild of Dr. Surya Singh, a healthcare leader
                  with over 20 years of experience. It began as a simple idea
                  and a basic interface. To turn it into the refreshing new way
                  of offering holistic health solutions it is now, gWell needed
                  a software development expert. They needed someone to develop
                  a robust and appealing mobile and web application. In 2020,
                  gWell was looking for software development and data analytics
                  companies in Boston. Singh turned to his good friend, Rudra
                  Pandey, with whom he had worked together before. Rudra had a
                  brainchild of his own in the US – Deerhold, a software
                  development company based in Boston with subsidiaries in Nepal
                  and Japan.
                </p>

                <h3>gWell Software Development</h3>

                <p>
                  When Deerhold joined this project, gWell had an
                  invitation-based model. Clinicians had access to the website
                  and would invite individuals to use it. As they changed to a
                  subscription-based model, gWell needed more features to
                  support their commercial growth. At first, gWell hired three
                  contractors to work on their platform. Deerhold was only
                  contracted for the mobile application development. The
                  coordination and communication required between the teams were
                  substantial. This proved to be challenging and unproductive.
                  As a result, the client gave the whole digital platform
                  development project over to Deerhold. We were delighted that
                  gWell trusted us with executing this project. We had impressed
                  them with our initial work and our open and respectful work
                  ethic. The software development process was not well-defined
                  because there had been many parties involved.At Deerhold,
                  project management is one of our strengths. Once we were
                  leading the project, our first step was to define the process.
                  We did so with the help of a product manager and gWell’s CTO.
                  The project went on a lot smoother after that. Deerhold went
                  on to build an engaging mobile application and a web portal.
                  Our team had 12 members consisting of software engineers and
                  quality assurance specialists. The web team handled the
                  back-end development. They used Application Platform
                  Interfaces (API) and Amazon Web Services. The mobile team
                  designed the app, using Squarespace as a third-party service
                  for subscriptions. Together, our team worked on third party
                  integrations, and communication and chatting functions. They
                  also enhanced gWell’s recommendation engine. Finally, the
                  gWell digital platform was completed. We had worked with the
                  gWell team to best support their vision for a transparent and
                  holistic wellness service.
                </p>
                <div className="casestudy-image">
                  <img
                    src="https://dh-uat-website-hosting.s3.amazonaws.com/dh-medias/1676006081367"
                    alt="banner image"
                  />
                </div>
                <br />
                <h3>How gWell works</h3>

                <p>
                  Users download the gWell app and request a DNA kit. gWell has
                  teamed up with Helix Labs that sequences the DNA sample. The
                  data is accessed through an API, and suitable diagnoses and
                  health plans are provided. The gWell app forecasts what
                  diseases the customer is prone to, like diabetes, osteoporosis
                  or cancer. It then provides individual plans on the behaviour
                  patterns the customer should follow to lower their risk. The
                  application also allows the customer to share their wellness
                  story and goals. These are analyzed by gWell’s expert team of
                  healthcare professionals. This adds a human element to a
                  digital process. Wellness coaches help individuals understand
                  and implement their suggested action plans. The customer can
                  also use the user-friendly app to update their goals and note
                  their health symptoms. They can track their completed actions
                  and progress. This helps the platform and coaches to adapt
                  recommendations over time. Every person is different and has
                  their own goals and needs. An individual can get better care
                  with a unique wellness plan tailored for them. gWell’s model
                  puts the individual at the center of its operation. The
                  software platform that we designed assesses individuals on a
                  variety of metrics. It meticulously analyzes the data. The
                  goal is to give accurate, evidence-based results. Our
                  interface is designed to be engaging and effective for
                  individuals of all ages.{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="blue-bg-content">
            <div className="container">
              <h3>Software Development Outcomes</h3>

              <p>
                gWell was happy with the product and our working relationship.
                The Deerhold team had a versatile repertoire of software
                services. This was a huge advantage for a start-up like gWell.
                They were happy with our initial mobile application development,
                which included the back-end API work. When they required UI/UX
                resources added to the app, we had the expertise to provide that
                too. After working with such a cutting-edge company, we have a
                new-found respect for healthcare services. gWell is transforming
                access to healthcare and medical advancements. They are making
                genomics accessible and reshaping the important conversation of
                wellness. We are proud to have used our software development
                skills to help create that shift.
              </p>
            </div>
          </div>
        </section>
      </section>
    </Layout>
  );
};

export default CaseStudy2;

export const Head = () => (
  <SEO
    title="Deerhold: A Smart Wellness Digital Solution"
    keywords="Case Study, Software Solution, Healthcare Platform, IoT Solutions, Data analytics, Healthcare data, Healthcare price transparency, Price transparency, Software Development, Healthcare Contracting, Health Plan "
    description="gWell is a health start-up based in Boston that provides individualized health plans. What sets gWell apart is their use of genomics for advanced and accurate results. Their smart wellness platform uses affordable gene sequencing techniques."
    pathname="/a-smart-wellness-digital-solution"
    image="/DeerholdOG.jpg"
  />
);
